import {
  chakra,
  Box,
  Flex,
  HStack,
  Link,
  IconButton,
  Button,
  useDisclosure,
  useColorModeValue,
  Stack,
  Heading,
} from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon, ExternalLinkIcon } from '@chakra-ui/icons';
import { ColorModeSwitcher } from "./ColorModeSwitcher"
import logo from "../images/logo-64.svg"

type pageConfig = {
  url: string,
  isExternal?: boolean
};

const navPages: { [key: string]: pageConfig } = {
  Docs: {
    url: 'https://chengh826.gitbook.io/crangon-docs/',
    isExternal: true
  },
  Features: {
    url: '/#feature'
  },
  FAQ: {
    url: '/#faq'
  },
  // Team: {
  //   url: '/#team'
  // },
  Partners: {
    url: '/#partners'
  },
  Community: {
    url: '/#community'
  }
};

const NavLink = ({ children }: { children: string }) => (
  <Link
    px={2}
    py={1}
    rounded={'md'}
    _hover={{
      textDecoration: 'none',
      bg: useColorModeValue('gray.200', 'gray.700'),
    }}
    href={navPages[children].url}
    isExternal={navPages[children].isExternal}>
    {children}
    {navPages[children].isExternal ? <ExternalLinkIcon mx='2px' /> : null}
  </Link>
);

export default function NavBar() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Box bg={useColorModeValue('gray.200', 'gray.900')} px={8}>
        <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
          <IconButton
            size={'md'}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label={'Open Menu'}
            display={{ md: 'none' }}
            onClick={isOpen ? onClose : onOpen}
          />
          <Link href={'#'} _hover={{textDecoration: 'none'}}>
            <HStack spacing={4} alignItems={'center'} fontSize='24'>
              <chakra.img src={logo}/>
              <Box fontWeight='bold'><Heading fontSize={'3xl'}>Crangon</Heading></Box>
            </HStack>
          </Link>
          <Flex alignItems={'center'}>
            <HStack
              as={'nav'}
              spacing={4}
              display={{ base: 'none', md: 'flex' }}
              px={5}>
              {Object.keys(navPages).map((link) => (
                <NavLink key={link}>{link}</NavLink>
              ))}
            </HStack>
            {/* <ColorModeSwitcher justifySelf="flex-end" /> */}
            <a href='https://crangon.web.app/'>
              <Button
                variant={'solid'}
                colorScheme={'yellow'}
                size={'md'}
                mr={4}>
                Launch App
              </Button>
            </a>
          </Flex>
        </Flex>

        {isOpen ? (
          <Box pb={4} display={{ md: 'none' }}>
            <Stack as={'nav'} spacing={4}>
              {Object.keys(navPages).map((link) => (
                <NavLink key={link}>{link}</NavLink>
              ))}
            </Stack>
          </Box>
        ) : null}
      </Box>
    </>
  );
}
